/* eslint-disable */
import axios from "axios";
import { getLocalToken, clearLocalStorage } from "utils/storage";

export const API = axios.create({
  baseURL: window.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL_JAVA,
  //  baseURL: "http://192.168.1.79:8081",
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: (status) => {
    return true;
  },
});

API.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      // if (response.data.title === "Unauthorized"
      //   || response.data.title === "User was locked"
      //   || response.data.title === "User not found"
      // ) clearLocalStorage(true);
    }
    return response;
  },
  (error) => {
    console.warn("Error status: ", error.response.status);
  }
);

API.interceptors.request.use((request) => {
  const token = getLocalToken();
  // ✅ Chỉ KHÔNG gắn token nếu là API public
  const isPublicApi = request.url?.startsWith("/api/public/");

  const isException = request.url?.startsWith("/api/public/attachments/preview");

  if (token && (!isPublicApi || isException)) {
    request.headers.Authorization = "Bearer " + token;
  }

  return request;
});

/**
 *
 * @param {boolean} success
 * @param {object} message
 * @property {boolean} success
 * @property {object} message
 */
export function standardResponse(success, message) {
  return {
    success,
    message,
  };
}

export const API_PROVINCE = axios.create({
  baseURL: "https://vapi.vnappmob.com/api",
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: (status) => {
    return true;
  },
});
export const APICookie = axios.create({
  baseURL: window.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL_JAVA,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // <<< THÊM DÒNG NÀY
  validateStatus: (status) => {
    return true;
  },
});
APICookie.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      if (
        response.data.title === "Unauthorized" ||
        response.data.title === "User was locked" ||
        response.data.title === "User not found"
      )
        clearLocalStorage(true);
    }
    return response;
  },
  (error) => {
    console.warn("Error status: ", error.response?.status);
  }
);

APICookie.interceptors.request.use((request) => {
  const token = getLocalToken();
  if (token) request.headers.Authorization = "Bearer " + token;
  return request;
});
